<div class="dialog_main">
  <button class="dialog_close" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  <div class="dialog_body">
    <div class="top_title hd_5">
      <h2>{{ 'ForgotPassword' | translate }}</h2>
      <p>{{'oops!itlookslikeyou’veforgottenyourpassword.noworries,we’llhelpyouresetit.' | translate}}</p>
    </div>
    <form [formGroup]="forgotPasswordFormGroup" (ngSubmit)="onSubmit()">
      <mat-tab-group
        class="site_tabs"
        [selectedIndex]="selectedTab"
        (selectedTabChange)="onTabChange($event)">
        <mat-tab [label]="'ContinueWithEmail' | translate">
          <div class="form_feilds">
            <div class="form_group">
              <mat-form-field appearance="fill">
                <input
                  matInput
                  [placeholder]="'EmailAddress' | translate"
                  class="form_control"
                  formControlName="email" />
                @if (submitted) {
                  @for (err of emailErrors; track $index) {
                    @if (
                      forgotPasswordFormGroup.controls['email'].hasError(
                        err.key
                      )
                    ) {
                      <mat-error>{{ err.message | translate }} </mat-error>
                    }
                  }
                }
              </mat-form-field>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
      <div class="form_btn">
        <button class="btn btn_primary" type="submit">
          {{ 'Continue' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
